import config from 'src/constants/config';
import NormalButton from 'src/components/Buttons/NormalButton';
import React, { useRef } from 'react';
import SVG from 'src/components/Images/SvgRenderer';
import useStyles from './style';
import { setIsOpenWelcomeScreen } from 'src/store/actions/layout.actions';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux-hooks';
import { useTranslation } from 'react-i18next';
import { saveUserSettings } from 'src/utils/useUser';
import { createNotification } from 'src/utils/createNotification';

const Finish: React.FunctionComponent = () => {

  const dispatch = useAppDispatch();
  const classes = useStyles();
  const { t } = useTranslation();
  const userData = useAppSelector((state: any) => state.user);

  const isSaving = useRef(false);
  

  const handleFinish = async () => {
    if(isSaving.current === false) {
      const currentVersion = config.APP_WELCOME_SCREEN_VERSION;
      const result = await saveUserSettings(dispatch, userData, "customizations", ["welcomescreen"], currentVersion);
      if(result) {
        handleClose();
        isSaving.current = false;
      } else {
        createNotification(t('failed_setup'), "error");
        isSaving.current = false;
      }
    }
  };

  const handleClose = () => {
    dispatch(setIsOpenWelcomeScreen(false));
  };

  return (
    <div className={classes.section}>
      <div className={classes.leftSide}>
        <div className={classes.header}>
          <SVG src={config.APP_LOGO}/>
        </div>
        <div className={classes.content}>
          <h1>{t('setup_finished')}</h1>
          <p>{t('setup_finished_info')}</p>
          <NormalButton buttonType='primary' onClick={handleFinish}>
            {t('setup_close')}
          </NormalButton>
        </div>
      </div>
      <div className={classes.rightSide}>
        <div className={classes.icon}>
          <div className={classes.iconPlaceholder}>
            <SVG src="emoji"/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Finish;